<div class="modal-body">
  <div class="content">
    <div class="content__top">
      <i *ngIf="currentStep !== STEPS.SELECT_TYPE" class="icon-small-back" (click)="onGoBack()"></i>
      <h4 translate>company.dids.add-port-did.popup.title</h4>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <i class="icon-small-close"></i>
      </button>
    </div>
    <div class="content__main">
      <!-- START - STEP SELECT_TYPE -->
      <section *ngIf="currentStep === STEPS.SELECT_TYPE">
        <div class="content__main_selection">
          <label for="selection__radio" class="vox-label" translate>
            company.dids.add-port-did.popup.select-type.radio.label
          </label>
          <div class="selection__radio">
            <div class="vox-input-group">
              <label class="vox-field-label">
                <input type="radio" class="vox-radio" value="vd" [(ngModel)]="selectedType"
                  (click)="onSelectRadio(SELECTION_TYPE.VD)" />{{'company.dids.add-port-did.popup.select-type.radio.options.new'
                | translate}}
              </label>
            </div>
            <div class="vox-input-group">
              <label class="vox-field-label">
                <input type="radio" class="vox-radio" value="portability" [(ngModel)]="selectedType"
                  (click)="onSelectRadio(SELECTION_TYPE.PORTABILITY)" />{{'company.dids.add-port-did.popup.select-type.radio.options.ported'
                | translate}}
              </label>
            </div>
          </div>
          <div class="selection__status">
            <label for="selection__status__vd-dropdown" class="vox-label" translate>
              company.dids.add-port-did.popup.select-type.statuses.label
            </label>
            <div ngbDropdown class="vox-dropdown-input">
              <button class="selection__status__vd-dropdown_btn" id="selection__status__vd-dropdown" ngbDropdownToggle>
                {{selectedStatus | didStatus}}
              </button>
              <div ngbDropdownMenu class="selection__status__vd-dropdown_menu"
                aria-labelledby="selection__status__vd-dropdown">
                <button *ngFor="let status of statuses" ngbDropdownItem class="selection__status__vd-dropdown_item--new"
                  (click)="selectedStatus = status" type="button">
                  {{status | didStatus}}
                </button>
              </div>
            </div>
          </div>
          <div class="submit-container">
            <button class="vox-btn vox-btn-primary" type="submit" (click)="onSubmitSelection()"
              translate>company.dids.add-port-did.popup.select-type.submit</button>
          </div>
        </div>
      </section>
      <!-- END - STEP SELECT_TYPE -->
      <!-- START - STEP DID_DATA -->
      <section *ngIf="currentStep === STEPS.DID_DATA && !loading.getInitData">
        <gdp-add-port-did-form class="gdp-add-port-did-form" [availableProviders]="providers" [country]="country"
          (onChangeCountry)="getVDRequirements($event)" (onEmitFormValues)="didData = $event"></gdp-add-port-did-form>
        <div class="submit-container">
          <button class="vox-btn vox-btn-primary" type="submit" [disabled]="isDisabled()" (click)="onSubmitDidData()"
            [ladda]="loading.addDid">
            <span translate>{{getDidDataSubmitToken()}}</span>
          </button>
        </div>
      </section>
      <!-- END - STEP DID_DATA -->
      <!-- START - STEP ADD_VD -->
      <section *ngIf="currentStep === STEPS.ADD_VD && !loading.getDids">
        <ng-container *ngIf="showDidError">
          <div class="vox-inline-message vox-inline-message_light-grey">
            <div>
              <i class="icon-small-alert"></i>
              <span>
                <span class="vox-inline-message__disclaimer"
                  translate>company.dids.add-port-did.popup.error.disclaimer</span>
                <a class="vox-inline-message__link" (click)="getDids()"
                  translate>company.dids.add-port-did.popup.error.link</a>
              </span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="!showDidError">
          <gdp-verification-data-selection-form [language]="language" [country]="country" [requirements]="requirements"
            [allowNoVD]="false" [dids]="didsWithVerificationData" [isVerticalVDTable]="isVerticalVDTable"
            (onEmitVerificationData)="verificationData = $event"></gdp-verification-data-selection-form>
          <div class="submit-container">
            <button type="button" class="vox-btn vox-btn-primary" type="button" [disabled]="isDisabled()"
              (click)="planAddonHandling === 'manual' ? onSubmit() : onGoNext(STEPS.RECAP)">
              <span *ngIf="planAddonHandling !== 'manual'" translate>company.dids.add-port-did.popup.form.buttons.next</span>
              <span *ngIf="planAddonHandling === 'manual'" translate>company.dids.add-port-did.popup.form.buttons.add</span>
            </button>
          </div>
        </ng-container>
      </section>
      <!-- END - STEP ADD_VD -->
      <!-- START - STEP ADD_PORTBILITY_DOCS -->
      <section *ngIf="currentStep === STEPS.ADD_PORTBILITY_DOCS">
        <div *ngIf="!loading.addDid">
          <gdp-upload-portability-docs-form [country]="country.toUpperCase()"
            (onEmitDocs)="portabilityDocsForm = $event"></gdp-upload-portability-docs-form>
          <div class="submit-container">
            <button type="button" class="vox-btn vox-btn-primary" type="button" [disabled]="isDisabled()"
            (click)="planAddonHandling === 'manual' ? onSubmit() : onGoNext(STEPS.RECAP)">
              <span *ngIf="planAddonHandling !== 'manual'" translate>company.dids.add-port-did.popup.form.buttons.next</span>
              <span *ngIf="planAddonHandling === 'manual'" translate>company.dids.add-port-did.popup.form.buttons.port</span>
            </button>
          </div>
        </div>
        <div class="upload-docs-contrainer" *ngIf="loading.addDid">
          <ngx-skeleton-loader [theme]="{'height':'916px'}"></ngx-skeleton-loader>
        </div>
      </section>
      <!-- END - STEP ADD_PORTBILITY_DOCS -->
      <!-- START - STEP RECAP -->
      <section *ngIf="currentStep === STEPS.RECAP">
        <ng-container>
          <gdp-payment-info (onEstimateError)="estimateError = $event" [product]="product" [country]="country" [chargebeeAccount]="subscription.chargebee_account"
            [companyId]="companyId" [canModifyCoupon]="false">
          </gdp-payment-info>
          <gdp-subscription-change-checkboxes (onEmitFormValue)="checkboxesData = $event">
          </gdp-subscription-change-checkboxes>
          <div class="submit-container">
            <button class="vox-btn vox-btn-primary" type="submit" [disabled]="!checkboxesData.isValid || estimateError"
              [ladda]="loading.addDid" data-style="zoom-in" data-spinner-color="#fff" (click)="onSubmit()">
              <span *ngIf="selectedType === SELECTION_TYPE.VD" translate>
                company.dids.add-port-did.popup.form.buttons.add
              </span>
              <span *ngIf="selectedType === SELECTION_TYPE.PORTABILITY"
                translate>company.dids.add-port-did.popup.form.buttons.port</span>
            </button>
          </div>
        </ng-container>
      </section>
      <!-- END - STEP RECAP -->
      <div *ngIf="loading.getInitData || loading.getDids">
        <ngx-skeleton-loader [theme]="{'height': '600px', 'margin-top': '0px', 'mergin-bottom': '0px'}">
        </ngx-skeleton-loader>
      </div>
    </div>
  </div>
</div>